import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import {
  BooleanField,
  ChipField,
  Labeled,
  ReferenceArrayField,
  Show,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { activityRequests } from "api/activityApi";
import { SectionTitle } from "features/SectionTitle";

const ShowActivityForeignLanguages = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Show
      title="Детайли на чужд език"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Входящ тест">
              <BooleanField source="hasEntryTest" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceArrayField
              source="levels"
              reference={activityRequests.getActivityForeignLanguagesLevelsSelect()}
            >
              <Labeled label="Ниво">
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </Labeled>
            </ReferenceArrayField>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowActivityForeignLanguages;
